/*
 * @FilePath     : /es-template/src/store/index.js
 * @Author       : LiYang
 * @Date         : 2021-08-26 10:47:47
 * @LastEditTime : 2022-01-04 16:15:06
 * @LastEditors  : Please set LastEditors
 * @Description  : 类似vuex命名空间
 */

import { createStore } from '@didi/es-mpx-creator'

const PATH_REG = /^(\.\/)(.*[^/]+)(\/\w+\.js)/

function importAll (context) {
  return context.keys().reduce((target, path) => {
    const match = path.match(PATH_REG) || []
    // 以文件路径为key值
    if (match[2]) {
      target[match[2]] = context(path).default
    };

    return target
  }, {})
}

export const root = importAll(
  require.context('./modules/', true, /index(.js)$/)
)

export default createStore({
  deps: root
})
